// frontend/src/components/auth/EmailLinkAuth.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { sendEmailSignInLink } from '../../firebase/config';
import { apiCall } from '../../services/api';

const EmailLinkAuth = ({ onClose, appId = 'saleswit', selectedPlan = null, mode = 'signup' }) => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSendLink = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setError('Please enter your email address');
      return;
    }
    
    // Validate name field for signup mode
    if (mode === 'signup' && !name.trim()) {
      setError('Please enter your name');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      // If this is a signup attempt, check if user already exists
      if (mode === 'signup') {
        const checkResponse = await apiCall('/api/auth/check-user-exists', {
          method: 'POST',
          body: JSON.stringify({ email }),
        });
        
        const checkData = await checkResponse.json();
        
        if (checkData.exists) {
          setError('An account with this email already exists. Please log in instead.');
          setLoading(false);
          return;
        }
      }
      
      // Store the selected plan in localStorage for retrieval after email link auth
      if (selectedPlan && selectedPlan.id) {
        localStorage.setItem('selectedPlanId', selectedPlan.id);
      } else {
        localStorage.setItem('selectedPlanId', 'free_plan');
      }
      
      // Store the name in localStorage
      if (name) {
        localStorage.setItem('nameForSignIn', name);
      }
      
      await sendEmailSignInLink(email);
      setMessage(`A sign-in link has been sent to ${email}. Check your email to complete ${mode === 'signup' ? 'sign-up' : 'sign-in'}.`);
    } catch (err) {
      console.error('Error sending sign-in link:', err);
      setError('Failed to send sign-in link. Please try again.');
      localStorage.removeItem('emailForSignIn');
      localStorage.removeItem('selectedPlanId');
      localStorage.removeItem('nameForSignIn');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      {message && (
        <div className="bg-green-50 border-l-4 border-green-500 p-4 mb-4">
          <p className="text-sm text-green-700">{message}</p>
        </div>
      )}
      
      {error && (
        <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-4">
          <p className="text-sm text-red-700">{error}</p>
        </div>
      )}
      
      {!message && (
        <form onSubmit={handleSendLink} className="space-y-4">
          {/* Name field - only show for signup mode */}
          {mode === 'signup' && (
            <div>
              <label className="block text-sm font-medium text-gray-700">Name</label>
              <input
                type="text"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="mt-1 text-black block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-blue-500 focus:ring-blue-500"
                placeholder="Enter your name"
              />
            </div>
          )}
          
          <div>
            <label className="block text-sm font-medium text-gray-700">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 text-black block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-blue-500 focus:ring-blue-500"
              placeholder="Enter your email"
            />
          </div>
          
          <button
            type="submit"
            disabled={loading}
            className="w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:bg-gray-400"
          >
            {loading ? 'Sending link...' : `Send ${mode === 'signup' ? 'Sign-Up' : 'Sign-In'} Link`}
          </button>
        </form>
      )}
    </div>
  );
};

export default EmailLinkAuth;